import dayjs, { Dayjs } from 'dayjs';
import i18next from 'i18next';

import { calendarDateLabel, SmartDateTranslate } from '@/components/ui/smartDate/smartDate.util.ts';

type FormatDateConfig = { absolute?: boolean; timeOnly?: boolean; withTime?: boolean };

const translateDate: SmartDateTranslate = (key, options) =>
  i18next.t(`components.listDetails.date.${key}`, options);

export const formatDate = (date?: string, config?: FormatDateConfig): string => {
  if (!date) {
    return ' - ';
  }
  if (config?.timeOnly) {
    return dayjs(date).format('HH:mm');
  }
  return calendarDateLabel(dayjs(date), dayjs(), translateDate, {
    absolute: config?.absolute,
    withTime: Boolean(config?.withTime),
  });
};

export const formatDateJs = (date: Dayjs, config?: FormatDateConfig): string => {
  return formatDate(date.toISOString(), config);
};

export function formatDateToBackend(date: Dayjs): string;
export function formatDateToBackend(date?: Dayjs | null): string | undefined;
export function formatDateToBackend(date?: Dayjs | null) {
  if (!date) {
    return undefined;
  }
  return date.format('YYYY-MM-DD');
}
